module.exports = __webpack_public_path__ + "media/4.38cde192.mp3";